import { Component, OnInit, EventEmitter, Output} from '@angular/core';
import { CalculationsService } from '../services/calculations.service';
import { ModalConfirmationService } from '../services/modal-confirmation.service';
import { SearchService } from '../services/search.service';
import { MenuManagementService } from './services/menu-management.service';
import { ProgressService } from '../services/progress.service';
import {GritInterferenceTestService} from "../services/grit/grit.interference-test.service";
import {InterferenceTestModelStates} from "../models/grit/grit.enums";
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  standalone: false
})
export class MenuComponent implements OnInit {

  @Output() menuStateChange = new EventEmitter<boolean>();

constructor(public menuService: MenuManagementService,
   private searchService: SearchService,
   public calculationsService : CalculationsService,
   private confirmationModal : ModalConfirmationService,
   public progressService: ProgressService,
   public interferenceTestService : GritInterferenceTestService,
) {}

ngOnInit(): void {
}


toggleMenu(event){
  var target = event.target || event.srcElement || event.currentTarget;
  var idAttr = target.attributes.name;
  var optionName = idAttr.nodeValue;
  this.menuService.toogleMenu(optionName);

  if (this.checkActiveMenu()) {
    this.searchService.expanded = false;
    this.menuService.open = true;
    this.menuStateChange.emit(true);
  }
   else {
    this.searchService.expanded = true;
    this.menuService.open = false;
    this.menuStateChange.emit(false);
   }
}

confirmLogout(){
  this.confirmationModal.showMesssageConfirmationModal("Logout", "Are you sure you want to log out?", "Yes", "No", () => {
    environment.useB2cAuthentication || environment.useKeycloakAuthentication ? this.menuService.logout() : MenuComponent.oldLogout();
  });
}

public static oldLogout(){
  document.cookie = "AuthToken" + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  location.reload();
};

checkActiveMenu() : boolean {
  let toReturn : boolean = false;
  this.menuService.menuOptions.forEach((value: boolean, key: string) => {
    if(key != "calculation-results" && this.menuService.menuOptions[key]) {
      toReturn = true;
    }
  });
  return toReturn;
}

  protected readonly InterferenceTestModelStates = InterferenceTestModelStates;
}
